import { jsx as _jsx } from "react/jsx-runtime";
import ViewToggleButton from "./index";
function DesktopViewToggleButton() {
    return (_jsx(ViewToggleButton, { baseClass: "ms3-map-overlay__button", additionalClasses: "ms3-map-overlay__button--with-icon ms3-map-overlay__button--desktop-view-toggle", viewModifierClassPrefix: "ms3-map-overlay__button--desktop-view-toggle--" }));
}
export default DesktopViewToggleButton;
